<template>
  <div>
    <div class="listContent">
      <a-form :form="form" ref="filterForm" class="headForm" labelAlign="left" :label-col="labelCol">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="产品">
              <a-input type="text" v-model="form.productKeyword" placeholder="产品名称" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="配方">
              <a-input type="text" v-model="form.formulaCode" placeholder="配方代码" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="线路">
              <LineSelect ref="lineSelect" v-model="form.lineId"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="动物类型">
              <animal-select  @change="anmimlChange" :val="animal" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="是否推送">
              <a-select placeholder="推送状态" v-model="form.isPushEbs">
                <a-select-option :key="index" v-for="(item,index) in ['全部产品','未推送','已推送',]" :value="index -1">{{item}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="创建日期">
              <a-range-picker valueFormat="YYYY-MM-DD" v-model="form.createDate" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="推送日期">
              <a-range-picker valueFormat="YYYY-MM-DD" v-model="form.pushDate" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="状态">
              <a-select style="width: 100%" v-model="form.status">
                <a-select-option :value="0">显示</a-select-option>
                <a-select-option :value="1">隐藏</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="是否激活">
              <a-select placeholder="激活状态" v-model="form.isActivate">
                <a-select-option :key="index" v-for="(item,index) in ['未激活','已激活','全部产品']" :value="index">{{item}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item >
              <a-space>
                <a-button type="primary" html-type="submit" @click="submitForm">查询</a-button>
                <a-button @click="resetForm">清空</a-button>
              </a-space>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="container-block table">
    <div style="margin-bottom:10px">
      <!-- <a-button style="margin-right:10px" @click="deleteProduct" :disabled="!selectedRowKeys.length > 0" type="danger" ghost>批量删除</a-button> -->
<!--      <a-space>-->
<!--        <template v-for="el in buttonList">-->
<!--          <template v-if="el.code.indexOf('third') < 0">-->
<!--            <a-button-->
<!--              :key="el.id"-->
<!--              :type="el.code === 'add' ? 'primary' : el.code === 'delete' ? 'danger' : ''"-->
<!--              :class="{enable: !isDelete && el.code === 'show',forbidden: !isDelete && el.code === 'hide'}"-->
<!--              :ghost="el.code === 'delete'"-->
<!--              :disabled="(isDelete && (el.code === 'delete' || el.code === 'simulation' || el.code === 'show' || el.code === 'hide')) || (el.code === 'pushEBS' && isPush) || (isBatch && el.code === 'batchOperation')"-->
<!--              @click="clickFunc(el.path,el.code)"-->
<!--            >-->
<!--              {{el.name}}-->
<!--            </a-button>-->
<!--          </template>-->
<!--        </template>-->
<!--        <span v-if="isExport">-->
<!--          <a-button style="margin-right:10px" v-if="selectedRowKeys.length === 0" disabled>批量导出</a-button>-->
<!--          <a-dropdown style="margin-right:10px" v-else>-->
<!--            <a-button>批量导出</a-button>-->
<!--            <a-menu slot="overlay" @click="showExport">-->
<!--              <a-menu-item :key="0">产品配方报表</a-menu-item>-->
<!--              &lt;!&ndash; <a-menu-item :key="1">产品生产报表</a-menu-item>-->
<!--              <a-menu-item :key="2">产品成本报表</a-menu-item> &ndash;&gt;-->
<!--              <a-menu-item :key="3">产品对比报表</a-menu-item>-->
<!--            </a-menu>-->
<!--          </a-dropdown>-->
<!--        </span>-->
<!--        <template v-if="selectedRowKeys.length > 0">-->
<!--          <a-tag> 已选择 {{selectedRowKeys.length}} 个产品 </a-tag>-->
<!--        </template>-->
<!--      </a-space>-->

    </div>
      <a-table
        bordered
        :row-key="record => record.id"
        :pagination="pagination"
        @change="listChange"
        :scroll="{x: 1000}"
        :dataSource="list.records" :loading="productLoading" :columns="columns" >

        <template slot="pushEbsReasonTitle">
          调整原因
          <a-tooltip class="tip">
            <template slot="title">
              <p style="margin-bottom: 0;" v-for="el in reasonList" :key="el.dictKey">{{el.dictValue}}</p>
            </template>
            <a-icon type="info-circle" />
          </a-tooltip>
        </template>

        <a @click="toggleDetailVisible(record)" slot="productName" slot-scope="text,record">
          <a-icon v-if="record.isCopy" type="copy" />
          <a-tooltip class="tip">
            <template slot="title">
              查看产品详情
            </template>
            {{text}}
          </a-tooltip>
        </a>
        <div slot="date" slot-scope="text">
          <!-- <span :style="{color:text ? 'green' : '#1890ff'}">
            {{text == 1 ? '是' : '否'}}
          </span> -->
          {{text == 1 ? '是' : '否'}}
        </div>
        <div slot="version" slot-scope="text">
          <!-- <span :style="{color:record.isActivate == 1 ? 'green' : ''}">
            {{text}}
          </span> -->
          {{text}}
        </div>
        <div slot="activate" slot-scope="text,record">
          <a v-if="text" :style="{color:text ? 'green' : '#1890ff'}">{{text ? '是' : '否'}}</a>
          <a-dropdown v-else>
            <a :style="{color:text ? 'green' : '#1890ff'}">{{text ? '是' : '否'}}</a>
              <a-menu style="width:100px" slot="overlay" @click="e=>activateAction(record)">
              <a-menu-item v-for="(item,index) in ['激活']" :key="index">{{item}}</a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
        <div slot-scope="text" slot="errorMsg">
          <a v-if="text" @click="() => showMsg(text)">查看错误信息</a>
        </div>
        <template slot="pushEbsReason" slot-scope="text,r">
          <a-tooltip placement="top">
            <template slot="title">
              <p style="margin-bottom: 0;" v-for="el in getReason(text)" :key="el.key">{{el.name}}</p>
            </template>
            <a @click="() => showReasonModal(r)">{{text}}</a>
          </a-tooltip>
        </template>
        <div slot="option" slot-scope="text,item">
          <!-- deleteItem -->
          <a @click="toggleDetailVisible(item)">查看</a>
          <a style="margin-left: 10px" @click="showRestoreConfirm(item)">恢复</a>
          <!-- <a :disabled="item.formulaType === 3" @click="toggleCopyVisible(item)">复制</a><a-divider type="vertical" />
          <a-tooltip placement="left">
            <template v-if="item.isActivate == 0" slot="title">只有激活状态的产品才能进行推送</template>
            <a-button type="link" :disabled="item.isActivate == 0 || item.isPushEbs === 1" @click="pushEBS(item)">推送EBS</a-button>
          </a-tooltip> -->
          <!-- <a-tooltip placement="left">
              <template slot="title">暂未开放该功能</template>
              <a-button type="link" @click="pushEbs(item)">推送EBS</a-button>
          </a-tooltip> -->
          <!-- <a-divider type="vertical"/> -->
        </div>
      </a-table>
    </div>
    <product-detail :hidden="detailVisible" @cancel="toggleDetailVisible({})" />
  </div>
</template>
<script>
import ProductDetail from './modal/ProductDetail.vue'
import {productMixins} from './unitls'
import AnimalSelect from "@/components/Nhf/Compound/select/AnimalSelect.vue";
import LineSelect from "@/components/Common/components/LineSelect.vue";
export default {
  props: {
    btnList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {LineSelect, AnimalSelect, ProductDetail},
  mixins:[ productMixins],
  data(){
    return {
      version: 0,
      reasonObj: {},
      reasonList: [],
      pushEbsVisible: false,
      exportVisible: false,
      productIds: [],
      animal: [],
      exportKey: 0,
      exportItem: {},
      selfFactoryId: window.localStorage.getItem('factoryId'),
      labelCol: {style: {width: '60px'}},
      // labelCol: {span: 5},
      wrapperCol: {span: 10},
      list:{
        records:[]
      },
      form:{
        status: 0,isActivate: 2
      },
      detailVisible:false,
      copyVisible:false,
      productLoading:false,
      expandedRowKeys: [],
      selectedRowKeys: [],
      selectedRows: [],
      restoreRecord: {}, // 要恢复的记录
      columns:[
        {
          dataIndex:'productName',
          title:"产品名称",
          scopedSlots: {customRender: 'productName'},
          key:"productName",
          sorter: (a, b) => a.productCode.localeCompare(b.productName,'zh'),
          width: 160,
          // fixed: 'left'
        },
        // {
        //   dataIndex:'productCode',
        //   key:"productCode",
        //   title:"产品号",
        //   sorter: (a, b) => a.productCode.localeCompare(b.productCode,'zh'),
        //   width:120,
        //   // fixed: 'left'
        // },
        {
          dataIndex:'formulaCode',
          key:"formulaCode",
          title:"配方代码",
          sorter: (a, b) => a.formulaCode.localeCompare(b.formulaCode,'zh'),
          width:120
        },
        {
          dataIndex:'version',
          key:"version",
          title:"版本",
          scopedSlots: {customRender: 'version'},
          align:'center',
          sorter: (a, b) => a.version - b.version,
          width: 55
        },
        {
          dataIndex:'factoryName',
          key:"factoryName",
          title:"工厂名称",
          sorter: (a, b) => a.staffName.localeCompare(b.factoryName,'zh'),
          width:100
        },
        {
          dataIndex:'staffName',
          key:"staffName",
          title:"用户",
          sorter: (a, b) => a.staffName.localeCompare(b.staffName,'zh'),
          width: 60
        },
        {
          dataIndex:'createTime',
          key:"createTime",
          title:"创建时间",
          align:'center',
          sorter: (a, b) => new Date(a.createTime).getTime() - new Date(b.createTime).getTime(),
          width: 100
        },
        {
          dataIndex:'isActivate',
          key:"isActivate",
          title:"是否激活",
          scopedSlots: {customRender: 'activate'},
          align:'center',
          width: 65
        },
        {
          dataIndex:'isPushEbs',
          key:"isPushEbs",
          title:"原料推EBS",
          scopedSlots: {customRender: 'date'},
          align:'center',
          width: 70
        },
        {
          dataIndex:'pushStatus',
          key:"pushStatus",
          title:"指标推EBS",
          scopedSlots: {customRender: 'date'},
          align:'center',
          width: 70
        },
        {
          dataIndex:'pushTime',
          key:"pushTime",
          title:"推送时间",
          sorter: (a, b) => new Date(a.pushTime).getTime() - new Date(b.pushTime).getTime(),
          align:'center',
          width: 80
        },
        {
          dataIndex:'errorMsg',
          key:"errorMsg",
          title:"错误信息",
          scopedSlots: {customRender: 'errorMsg'},
          width: 65
        },
        {
          dataIndex:'pushEbsReason',
          key:"pushEbsReason",
          // title:"调整原因",
          slots: { title: 'pushEbsReasonTitle' },
          scopedSlots: {customRender: 'pushEbsReason'},
          width: 65
        },
        {
          title:"操作",
          scopedSlots: {customRender: 'option'},
          align:'center',
          width: 80
        }
      ],
      filterData:{},
      buttonList: [],
      isExport: false,
      maxLen: 50,
    }
  },
  watch: {
    btnList:{
      handler(val){
        this.getBtn(val)
      },
      deep: true
    },
  },
  mounted(){
    this.getReasonList()
    this.getBtn(this.btnList)
    this.getList()

    // let arr = [8,4,3,6,7,1,2]
    // let key = 3
    // arr.sort((a,b) => {
    //   if(a == key){
    //     return Math.ceil(a-b)
    //   }
    //   else if(b == key){
    //     return 0 - Math.ceil(a-b)
    //   }
    //   else{
    //     return a-b
    //   }
    // })
    // console.log(arr)
  },
  computed:{
    rowSelection() {
      return {
        selectedRowKeys:this.selectedRowKeys,
        onChange: (selectedRowKeys,selectedRows) => {
          selectedRowKeys = selectedRowKeys.splice(0,this.maxLen);
          this.selectedRowKeys = selectedRowKeys
          let arr = [...this.selectedRows, ...selectedRows]
          this.selectedRows = selectedRowKeys.map(i => {
            return arr.filter(item=>item.id === i)[0]
          })
        },
        getCheckboxProps: record => ({
          props: {
            disabled: !this.selectedRowKeys.includes(record.id) && this.selectedRowKeys.length >= this.maxLen
          },
        }),
      }
    },
    isDelete(){
      return this.selectedRowKeys.length === 0
    },
    isEdit(){
      return this.selectedRowKeys.length !== 1
    },
    isPush(){
      let flag = false
      this.selectedRows.forEach(el => {
        if(el.isActivate == 0 || el.isPushEbs === 1) flag = true
      })
      if(!this.selectedRows || this.selectedRows.length === 0) flag = true
      return flag
    },
    isBatch(){
      return this.selectedRowKeys.length === 0
    },
  },
  methods:{
    showReasonModal(r){
      let lst = this.getReason(r.pushEbsReason) || []
      let len = lst.length || 0
      this.$info({
        title: '调整原因',
        content: <div>
          <p>
            <span style={{width: '80px',display: 'inline-block'}}>原因类型：</span>
            {
              lst&&lst.map((el,index) => {
                return <span>{el.name}{(len - 1) === index ? '' : '；'}</span>
              })
            }
          </p>
          <p>
            <span style={{width: '80px',display: 'inline-block'}}>原因描述：</span>
            {r.reasonDescribe}
          </p>
        </div>
      });
    },
    getReason(text){
      let str = []
      if(text){
        let textArr = text.split(',')
        textArr.forEach(key => {
          let name = this.reasonObj[key]
          str.push({key,name})
        })
      }
      return str
    },
    anmimlChange(val) {
      this.animal = val;
      this.form.animalTypeCode = [...val].pop();
    },
    getReasonList(){
      this.$http.get('/iot-system/dict/list?code=ebs_reason').then(res => {
        let {success,data} = res || {}
        if(success){
          let list = []
          let reasonObj = {}
          if(data && data[0]){
            let obj = data[0] || {}
            if(obj.children) {
              list = obj.children || []
              list.forEach(el => {
                reasonObj[el.dictKey] = el.dictValue || ''
              })
              this.reasonObj = reasonObj || {}
            }
          }
          this.reasonList = list || []
        }else {
          this.reasonObj = {}
          this.reasonList = []
        }
      })
    },
    pushEBS(item){
      this.version = 0
      // this.isRow = false
      // if(item && item.id){
      //   if(item.version == 1){
      //     this.$confirm({
      //       title: '推送EBS',
      //       content: '确认将该产品推送到EBS吗?',
      //       okText: '继续',
      //       cancelText: '取消',
      //       onOk: async () =>{
      //         const hide = this.$message.loading('推送EBS中...', 0)
      //         let res = await this.fetchGet({
      //           actions:this.isPushEbsFormulaProduct,
      //           loading:'pushLoading',
      //           data:{
      //             // pushEbsFlag:'1',
      //             productId: item.id
      //           }
      //         })
      //         if(res.code === 400) this.$message.error(res.msg)
      //         this.getList(this.currentPage)
      //         setTimeout(hide, 0)
      //       },
      //       onCancel(){},
      //     })
      //   }else{
      //     this.productIds = [item.id]
      //     this.pushEbsVisible = true
      //   }
      // }else{
        if(item && item.id){
          this.version = item.version
          this.productIds = [item.id]
        }else{
          this.selectedRows.forEach(el => {
            this.version = Math.max(this.version || 0,el.version)
          })
          this.productIds = this.selectedRowKeys
        }
        // this.pushEbsVisible = true
        this.getLinkFactory()
      // }
    },
    getLinkFactory(){
      let params = {
        factoryId: window.localStorage.getItem('factoryId')
      }
      this.$http.get('/iot-factory/factorysublink/subFactoryList',{params}).then(res => {
        let {data,success} = res || {}
        if(success) {
          if(data.length > 0){
            this.pushEbsVisible = true
          }else{
            if(this.version == 1){
              this.$confirm({
                title: '推送EBS',
                content: '确认将该产品推送到EBS吗?',
                okText: '继续',
                cancelText: '取消',
                onOk: async () =>{
                  this.closeEBS({type: true,ebsPushFactoryId: this.selfFactoryId})
                },
                onCancel(){},
              })
            }else{
              this.pushEbsVisible = true
            }
          }
        }
      })
    },
    async closeEBS({type,ebsPushFactoryId}){
      if(type) {
        const hide = this.$message.loading('推送EBS中...', 0)
        let params = {
          // pushEbsFlag:'1',
          ebsPushFactoryId,
          ids: this.productIds.join(',')
        }
        this.$http.post('/nhf-app/formulaproduct/batchPushEbsProductIds',params).then(res => {
          let {success,data,msg} = res || {}
          if(success){
            if(data && data.length > 0) {
              let msg = data.map((el) => {
                return <p>{el}</p>
              })
              this.$warning({
                title: '请注意',
                content: msg,
                width: 600,
                onOk: () => {
                  this.getList(this.currentPage)
                }
              });
            }else{
              this.getList(this.currentPage)
            }
          }else{
            this.$message.warning(msg)
          }
        }).finally(() => {
          setTimeout(hide, 0)
        })

      }
      this.pushEbsVisible = false
    },
    async updateStatus(type){
      this.$confirm({
        title: "提示",
        content: type === 'show' ? "确认显示选中的配方吗？" : '确认隐藏选中的配方吗？',
        okText: "继续",
        cancelText: "取消",
        onOk: async () => {let data = {
          ids: this.selectedRowKeys.join(','),
          status: type === 'show' ? 0 : 1
        }
        await this.fetchPost({
          actions: this.batchUpdateProductStatus,
          data,
          loading: "feedLoading",
        });
        this.cleanSelect()
        this.getList(this.search)
        }
      })

    },
    clickFunc(functionName,type){
      this[functionName](type)
    },
    getBtn(val){
      let formula = val.find(el => el.code === 'customized-productList') || {}
      if(formula.children){
        this.buttonList = formula.children.filter(el => el.code !== "export") || []
        let obj = formula.children.find(el => el.code === 'export') || {}
        this.isExport = obj.id ? true : false
      }
    },
    closeExport(){
      this.exportVisible = false
    },
    exportPrice({priceList,fileName}){
      if(this.exportKey === 0 || this.exportKey === 3){
        if(priceList && priceList.length > 0){
          this.exportReportForm({key:this.exportKey,item: this.exportItem,priceList,fileName})
        }else{
          this.$message.warning('请选择价格来源')
        }
      }else{
        this.exportReportForm({key:this.exportKey,item:this.exportItem,fileName})
      }
    },
    showExport({key},item){
      this.exportKey = key
      this.exportItem = item
      this.exportVisible = true
    },
    turnTo(){
      this.$router.push('/system/nhf-export-management?name=导出管理')
      this.$notification.close('a')
    },
    exportReportForm({key,item,priceList,fileName}){
      if(this.selectedRowKeys.length > this.maxLen){
        this.$message.warning(`最多可选${this.maxLen}个产品`)
        return
      }
      let url = [
        // '/nhf-custom/custompro/batchExportCustomProExcelReport',
        '/nhf-custom/custompro/asyncBatchExportCustomProExcelReport',
        // '/nhf-app/formulaproduct/batchExportProductProExcelReport',
        '/nhf-app/formulaproduct/asyncBatchExportProductProExcelReport',
        // '/nhf-app/formulaproduct/downFormulaProductCostByProductId', // 产品成本报表
        '/nhf-app/formulaproduct/asyncDownFormulaProductCostByProductId',
        // '/nhf-custom/custompro/downCustomProDiffByProductId', // 产品对比报表
        '/nhf-custom/custompro/asyncDownCustomProDiffByProductId',
      ]
      let customIds = []
      let productIds = []
      this.selectedRows.forEach(el => {
        customIds.push(el.customId)
        productIds.push(el.id)
      })
      // let productIds = this.selectedRowKeys.join(',')
      let feild = ''
      if(item && item.id) {
        productIds = [item.id]
        customIds = [item.customId]
      }
      if(key === 0 || key === 1) {
        feild = 'ids'
      }else if(key === 2 || key === 3){
        feild = 'productIds'
      }
      if(!url[key]) return
      let aliasFlag = window.localStorage.getItem('overseasFlag') == 1 ? 1 : 0
      let params = {
        aliasFlag,
        factoryId: window.localStorage.getItem('factoryId'),
        customIds: customIds.join(','),
        [feild]: productIds.join(','),
        priceList: priceList ? priceList.join(',') : undefined,
        fileName
        // customId: item ? item.customId : undefined,
        // factoryId: item ? item.factoryId : undefined
      }
      this.$get(url[key],params).then(res => {
        let {success} = res || {}
        if(success) {
          this.$notification.success({
            key: 'a',
            message: <h3>导出任务提示</h3>,
            duration: 10,
            description: <div>
              <p>你所提交的导出任务已经创建，请前往导出管理中查看进度和下载文件！</p>
              <a onClick={this.turnTo}>前往导出管理</a>
            </div>,
          });
        }
      })
      // this.$notification.open({
      //   key: 'a',
      //   message: <h3>导出提示</h3>,
      //   description: '正在执行导出任务，请稍后',
      // });
      // this.$fileDownload(url[key],data).then(() => {
      //   this.$notification.close('a')
      //   this.$notification.open({
      //     message: <h3>导出成功</h3>,
      //     description: '已导出成功，请前往Download查看！',
      //     icon: <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" />,
      //   });
      // }).catch(() => {
      //   this.$notification.close('a')
      //   this.$notification.open({
      //     message: <h3>导出失败</h3>,
      //     description: '文件导出失败，请重新导出',
      //     icon: <a-icon type="close-circle" theme="twoTone" two-tone-color="red" />,
      //   });
      // })
      this.exportVisible = false
    },
    getCheckboxProps(record){
      return ({
        props: {
          disabled: record.isActivate === 1 || record.isPushEbs === 1,
        }
      })
    },
    // async getChildList(status,item){
    //   if(status){
    //     this.expandedRowKeys = [...this.expandedRowKeys,item.id]
    //     const {formulaCode} = item
    //     const res = await this.getCustomProPageByCond({
    //       formulaCode,
    //       isActivate:0,
    //       factoryId:this.factoryId,
    //       status: this.form.status,
    //       query: {
    //         current: 1,
    //         size: 90,
    //       }
    //     })
    //     const index = this.list.records.findIndex(i=>i.id === item.id)
    //     let list = [...this.list.records]
    //     list.splice(index,1,{...this.list.records[index],children:res.data.records})
    //     this.list.records = list
    //   } else{
    //     const index = this.expandedRowKeys.findIndex(i=>i === item.id)
    //     let list = [...this.expandedRowKeys]
    //     list.splice(index,1)
    //     this.expandedRowKeys = list
    //   }
    // },
    showMsg(content){
      this.$error({
        title: '推送错误信息',
        content,
        okText: '确定',
        width: 650
      });
    },
    copySuccess(){
      this.toggleCopyVisible({})
      this.getList()
      this.expandedRowKeys = []
    },
    toggleCopyVisible({id}){
      this.copyVisible = id || false
    },
    toggleDetailVisible({id}){
      // this.detailVisible = id || false
      this.$router.push(`/archive-data/archive-data-customized-product-list/archive-data-customized-product-detail?name=定制料归档详情&id=${id}`)
    },
    async getList(arg = {}){
      this.expandedRowKeys = []
      this.selectedRowKeys = []
      this.selectedRows = []
      let {size=20,current=1} = arg || {}
      let pageSize = window.localStorage.getItem("nhfProductListPageSize") ? Number(window.localStorage.getItem("nhfProductListPageSize")) : 20;
      if (pageSize) size = pageSize
      let query = {size,current}
      const res = await this.fetchPost({
        actions:this.getCustomProPageByCond,
        showMessage: false,
        name:'list',
        loading:'productLoading',
        isList:true,
        data:{
          query,
          factoryId:window.localStorage.getItem('factoryId'),
          status: this.form.status,
          ...this.filterData,
          ...arg,
          isActivate: this.form.isActivate == 2 ? undefined : this.form.isActivate,
        }
      })
      this.list.records = res.records.map(i=>{
       return {...i}
      })
    },

    deleteProduct(){
      this.$confirm({
        title: '删除产品',
        content: '确定将选中的产品从记录中删除吗？',
        cancelText:'取消',
        okText:'继续',
        onOk: () => this.deleteItem(),
      })
    },

    async deleteItem(record){
      // const ids = this.selectedRows.map(i=>i.id).join()
      if(record && record.id){
        this.$confirm({
          title: '删除产品',
          content: '确定将该产品从记录中删除吗？',
          cancelText:'取消',
          okText:'继续',
          onOk: async () => {
            const ids = record.id
            await this.fetchPost({
              actions:this.removeCustomProByIds,
              data:{
                ids
              }
            })
            this.getList()
            this.cleanSelect()
          },
        })
      }else{
        const ids = this.selectedRowKeys.join(',')
        await this.fetchPost({
          actions:this.removeCustomProByIds,
          data:{
            ids
          }
        })
        this.getList()
        this.cleanSelect()
      }
    },

    async activateAction({id:productId}){
      const hide = this.$message.loading('激活状态更改中...', 0)
      let res = await this.fetchGet({
        actions:this.isActivateCustomPro,
        data:{
          activateFlag:1,
          productId
        }
      })
      setTimeout(hide, 0)
      let {success,msg} = res || {}
      let msgFeild = 'warning'
      if(success) msgFeild = 'success'
      this.$message[msgFeild](msg)
      await this.getList(this.currentPage)
    },

    async pushEbs({id}){
      this.$confirm({
        title: '推送EBS',
        content: '确认将该产品推送到EBS吗?',
        okText: '继续',
        cancelText: '取消',
        onOk: async () =>{
          const hide = this.$message.loading('推送EBS中...', 0)
          let res = await this.fetchGet({
            actions:this.isPushEbsFormulaProduct,
            loading:'pushLoading',
            data:{
              // pushEbsFlag:'1',
              productId:id
            }
          })
          if(res.code === 400) this.$message.error(res.msg)
          await this.getList(this.currentPage)
          setTimeout(hide, 0)
        },
        onCancel(){},
      })

    },
    timeStr(arg){
      return [`${arg[0]} 00:00:00`,`${arg[1]} 23:59:59`]
    },
    submitForm(){
      let {createDate,pushDate,isPushEbs,...other} = this.form
      let arr = {...other,isPushEbs}
      if(createDate && createDate.length) {
        const [createTimeStart,createTimeEnd] = this.timeStr(createDate)
        arr = {...arr,createTimeStart,createTimeEnd}
      }
      if(pushDate && pushDate.length) {
        const [pushTimeStart,pushTimeEnd] = this.timeStr(pushDate)
        arr = {...arr,pushTimeStart,pushTimeEnd}
      }
      // if(isActivate === -1) arr ={...arr,isActivate:''}
      if(isPushEbs === -1) arr ={...arr,isPushEbs:''}
      this.filterData = arr
      this.getList(arr)
    },
    resetForm(){
      this.form = {status: 0,isActivate: 2}
      this.filterData = {}
      this.animal = [];
      this.getList()
      this.$refs.lineSelect.reset()
    },
    listChange(page){
      let {pageSize} = page || {}
      window.localStorage.setItem('nhfProductListPageSize',pageSize)
      this.getList({...this.tablePageChange(page),...this.form})
    },
    batchActivation(){
      let flag = this.selectedRows.find(el => el.isActivate === 0)
      if(flag){
        this.batchHandle('active')
      }else{
        this.$message.warning('没有可激活产品')
      }
    },
    batchInvalidation(){
      let flag = this.selectedRows.find(el => el.isActivate === 1)
      if(flag){
        this.batchHandle('invalid')
      }else{
        this.$message.warning('没有可失效产品')
      }
    },
    batchHandle(type){
      let title = type === 'active' ? '批量激活' : '批量失效'
      let content = type == 'active' ? <span style={{color: 'red'}}>将选中产品状态批量修改为激活？</span> : <span style={{color: 'red'}}>将选中产品状态批量修改为失效？</span>
      this.$confirm({
        title,
        content,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          await this.fetchPost({
            actions:this.batchSetActivateFlagByFormulaProductIds,
            data:{
              productIds: this.selectedRowKeys,
              activateFlag: type === 'active' ? 1 : 0
            }
          })
          this.getList({current: this.pagination.current,size: this.pagination.pageSize})
          this.cleanSelect()
        },
      })
    },
    // 显示恢复确认框
    showRestoreConfirm(record) {
      if (record && record.id) {
        this.restoreRecord = record;
        this.$confirm({
          title: '产品数据恢复',
          content: `确认将产品《${record.productName}》的数据进行恢复吗？`,
          cancelText: '取消',
          okText: '确定',
          onOk: () => {
            return this.handleRestore();
          },
          onCancel: () => {
            this.restoreRecord = {};
          }
        });
      }
    },
    // 处理恢复操作
    handleRestore() {
      const productId = this.restoreRecord.id;

      // 调用恢复接口
      return this.$http.post('/nhf-custom/archivedCustomProduct/restoreArchivedCustomProduct', null, {
        params: { productId }
      }).then(res => {
        if (res.success) {
          this.$message.success('产品数据恢复成功');
          this.getList(); // 刷新列表
        } else {
          this.$message.error(res.message || '恢复失败');
        }
        this.restoreRecord = {};
        return res;
      }).catch(err => {
        this.$message.error('恢复失败: ' + (err.message || '网络错误'));
        this.restoreRecord = {};
      });
    }
  }
}
</script>

<style lang="scss" scoped>
 ::v-deep .ant-tooltip-inner{
    font-size: 12px;
  }
  ::v-deep .ant-pagination-total-text >div{
    font-size: 12px;
  }
.enable{
  background: #02830f;
  color: #fff;
  border: none;
  &:hover{
    background: #14811f;
  }
}
.forbidden{
  background: #f59a23;
  color: #fff;
  border: none;
  &:hover{
    background: #f7ab47;
  }
}
</style>
<style lang="scss">
  .modalClass{
    height: 300px;
    overflow: auto;
  }
  .ant-modal-confirm-content{
    max-height: 350px;
    overflow: auto;
  }
  .setGrey{
    color: #999;
  }
</style>
